export const colorTable = [
  "#5470c6",
  "#91cc75",
  "#fac858",
  "#ee6666",
  "#73c0de",
  "#3ba272",
  "#fc8452",
  "#9a60b4",
  "#ea7ccc"
]

export const colors = {
  careNet: {
    main: "#ad0026",
    contrastText: "#fff"
  },
  dpc: {
    main: "#ee6666",
    contrastText: "#fff"
  },
  cancer: {
    main: "#5470c6",
    contrastText: "#fff"
  },
  trial: {
    main: "#fc8452",
    contrastText: "#fff"
  },
  journal: {
    main: "#3ba272",
    contrastText: "#fff"
  },
  senmoni: {
    main: "#9a60b4",
    contrastText: "#fff"
  },
  research: {
    main: "#60b49fff",
    contrastText: "#fff"
  },
  news: {
    main: "#3ba272",
    contrastText: "#fff"
  },
  mrp: {
    main: "#5470c6",
    contrastText: "#fff"
  },
  live: {
    main: "#fc8452",
    contrastText: "#fff"
  },
  picks: {
    main: "#ad0026",
    contrastText: "#fff"
  },
  other: {
    main: "rgba(0, 0, 0, 0.08)",
    contrastText: "#000"
  }
}
